<div mat-dialog-title class="dialog-info horizontal-padding m-0" closeOnEscape>
    <label class="dialogTitle">
        {{'ACTION_NEEDED' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none dialogCross" (click)="onCancelClick()"></button>
</div>
<mat-dialog-content class="horizontal-padding">
    <div class="m-0">
        <span>
            {{'CHECKLIST_SELECTIONS' | translate}}
        </span>
    </div>
    <fieldset>
        <legend>
            {{'PENDING_ITEMS' | translate}}
        </legend>

        @for (item of actionNeededCollection; track item.type) {

            <!-- Radio-button: VP / BGM Approval (Yes/No) -->
            @if (item.vpOrBgmApprovalVisible) {
            <div class="row m-0 align-items-center">
                <div class="col-sm-5 p-0 d-flex align-items-center">
                    <span>
                        {{ item.label }}
                    </span>
                    @if (item.isTooltipVisible) {
                        <mat-icon class="info-icon ms-2" [matTooltip]="item.actionTooltip ?? ''">info</mat-icon>
                    }
                </div>
                <div class="col-sm-7 p-0">
                    <mat-radio-group [name]="item.radioButtonGroupName"
                                     [(ngModel)]="item.isAction"
                                     [ngModelOptions]="{ standalone: true }">
                        <mat-radio-button color="primary" [value]="true">
                            {{'YES' | translate}}
                        </mat-radio-button>
                        <mat-radio-button color="primary" [value]="false">
                            {{'NO' | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            }

            <!-- Textbox: Approver Email -->
            @if (item.isApproverEmailTextboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'approverEmail_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput
                               [id]="'approverEmail_' + $index"
                               maxlength="50"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }">
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Fire Reason For Exception -->
            @if (item.isFireComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'fireReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 ">
                        <input matInput
                               [id]="'fireReason_' + $index"
                               [matAutocomplete]="fireReasonAuto"
                               #fireReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="fireReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #fireReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(fireReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }
            @if (item.isFireJobDetailsVisible) {
              <div class="row row-height m-0 align-items-baseline">
                  <div class="col-sm-5 p-0">
                      <label>{{item.label}}</label>
                  </div>
                  <div class="col-sm-7 p-0">
                    <button mat-raised-button color="primary" (click)="openJobDetailsDialog()">{{'JOB_DETAILS' | translate}}</button>
                  </div>
              </div>                
            }
            <!-- Combobox: Automation Reason For Exception -->
            @if (item.isAutomationComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'automationReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'automationReason_' + $index"
                               [matAutocomplete]="automationReasonAuto"
                               #automationReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="automationReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #automationReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(automationReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Electrical Reason For Exception -->
            @if (item.isElectricalComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'electricalReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'electricalReason_' + $index"
                               [matAutocomplete]="electricalReasonAuto"
                               #electricalReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="electricalReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #electricalReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(electricalReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Mechanical Reason For Exception -->
            @if (item.isMechanicalComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'mechanicalReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'mechanicalReason_' + $index"
                               [matAutocomplete]="mechanicalReasonAuto"
                               #mechanicalReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="mechanicalReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #mechanicalReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(mechanicalReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Radio-button: Engineer Approval (Yes/No) -->
            @if (item.isEngineerApprovalVisible) {
            <div class="row m-0 align-items-center">
                <div class="col-sm-5 p-0">
                    <span>
                        {{ item.label }}
                    </span>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-radio-group [name]="'engineerApproval_' + $index"
                                     [(ngModel)]="item.isEngineerApproval"
                                     [ngModelOptions]="{ standalone: true }">
                        <mat-radio-button color="primary" [value]="true">
                            {{'YES' | translate}}
                        </mat-radio-button>
                        <mat-radio-button color="primary" [value]="false">
                            {{'NO' | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            }

            <!-- Textbox: Engineer Approver Email -->
            @if (item.isEngineerApproverEmailTextboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'engineerApproverEmail_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12">
                        <input matInput
                               [id]="'engineerApproverEmail_' + $index"
                               maxlength="50"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }">
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Engineer Reason For Exception -->
            @if (item.isEngineerReasonForExceptionComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'engineerReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'engineerReason_' + $index"
                               [matAutocomplete]="engineerReasonAuto"
                               #engineerReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="engineerReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #engineerReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(engineerReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Prefab Reason For Exception -->
            @if (item.isPrefabReasonForExceptionComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'prefabReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'prefabReason_' + $index"
                               [matAutocomplete]="prefabReasonAuto"
                               #prefabReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="prefabReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #prefabReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(prefabReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Radio-button: SM Approval (TBE) -->
            @if (item.isSMApprovalVisible) {
            <div class="row m-0 align-items-center">
                <div class="col-sm-5 p-0 d-flex align-items-center">
                    <span>
                        {{ item.label }}
                    </span>
                    @if (item.isTooltipVisible) {
                        <mat-icon class="info-icon ms-2" [matTooltip]="item.actionTooltip ?? ''">info</mat-icon>
                    }
                </div>
                <div class="col-sm-7 p-0">
                    <mat-radio-group [(ngModel)]="item.isSMApproval"
                                     [ngModelOptions]="{ standalone: true }">
                        <mat-radio-button color="primary" [value]="true">
                            {{'YES' | translate}}
                        </mat-radio-button>
                        <mat-radio-button color="primary" [value]="false">
                            {{'NO' | translate}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            }

            <!-- Combobox: Security Reason For Exception -->
            @if (item.isSecurityComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'securityReason_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'securityReason_' + $index"
                               [matAutocomplete]="securityReasonAuto"
                               #securityReasonTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="securityReasonTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <!-- TO-DO: populate securityReasonForExceptionOptions with actual data -->
                        <mat-autocomplete #securityReasonAuto="matAutocomplete">
                            @for (reason of filterOptions(securityReasonForExceptionOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

            <!-- Combobox: Security Reason For Labor Variance -->
            @if (item.isSecurityReasonForLaborVarianceComboboxVisible) {
            <div class="row row-height m-0 align-items-baseline">
                <div class="col-sm-5 p-0">
                    <label [attr.for]="'laborVariance_' + $index">
                        {{ item.label }}
                    </label>
                </div>
                <div class="col-sm-7 p-0">
                    <mat-form-field appearance="outline" class="col-sm-12 optionHeight">
                        <input matInput
                               [id]="'laborVariance_' + $index"
                               [matAutocomplete]="laborVarianceAuto"
                               #laborVarianceTrigger="matAutocompleteTrigger"
                               [(ngModel)]="item.actionTextValue"
                               [ngModelOptions]="{ standalone: true }"
                               [placeholder]="'COMMON_LABELS.SELECT_FROM_LIST_OR_ENTER_OTHER_HERE' | translate">
                        <button matSuffix mat-icon-button type="button" tabindex="-1"
                                (click)="laborVarianceTrigger.openPanel()">
                            <mat-icon class="d-flex align-items-center">arrow_drop_down</mat-icon>
                        </button>
                        <mat-autocomplete #laborVarianceAuto="matAutocomplete">
                            @for (reason of filterOptions(securityReasonForLaborVarianceOptions, item.actionTextValue); track reason) {
                                <mat-option class="optionHeight" [value]="reason">
                                    {{ reason }}
                                </mat-option>
                            }
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            }

        }

    </fieldset>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions-style">
    <button mat-raised-button color="primary" (click)="onOkClick()">
        {{'OK_BTN_LABEL' | translate}}
    </button>
    <button mat-raised-button color="warn" (click)="onCancelClick()">
        {{'CANCEL_BTN_LABEL' | translate}}
    </button>
</mat-dialog-actions>
       
       